import React, { useRef, useEffect, useState } from "react";
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBBtn,
  MDBIcon,
  MDBTable,
  MDBTableHead,
  MDBTableBody,
} from "mdb-react-ui-kit";

import { useLocation, useNavigate } from "react-router-dom";
import Table from "../Table";
import DataTable from "../DataTable";
import voucherDateAndTimeFormatter from "../../utilities/voucherDateAndTimeFormatter";
import NewRegisteredRequestDataTable from "./NewRegisteredRequestDataTable";
import axios from "axios";
import Loader from "../Loader";
import API_BASE_URL from "../../utilities/apiConfig";
import axiosInstance from "../../utilities/apiConfig";

const NewRegReq = () => {
  const [loading, setLoading] = useState(false);
  const [pendingMembershipDetails, setPendingMembershipDetails] = useState([]);

  // const navigate = useNavigate();
  // const location = useLocation();
  // const { NewRegistrationRequest } = location.state;

  const handleGetPendingRegistrationRequest = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `/Registration/pending_registration_requests`
      );

      console.log("pending request data", response.data);
      if (response.data.response.statusCode === 200) {
        setPendingMembershipDetails(response.data.pendingRequests);
      } else {
        setPendingMembershipDetails([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const formatRegData = voucherDateAndTimeFormatter(pendingMembershipDetails, [
    "appliedDate",
    "registrationDate",
    "requestedTimePreiodDate",
    "appliedDate",
    "dateOfBirth",
    "mentorJoiningDate",
    "retirementYear",
  ]);

  const handleClick = (event, cellValues) => {
    console.log("button executed", cellValues);
  };

  const newMembershipRequestTableColumns = [
    {
      field: "advocateBarId",
      headerName: "Registration No",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },

    {
      field: "name",
      headerName: "Name",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "relationshipType",
      headerName: "Relationship Type",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "relativeName",
      headerName: "Relative Name",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "mobileNumber",
      headerName: "Mobile Number",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "email",
      headerName: "Email",
      minWidth: 180,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    // { field: 'permanentAddress', headerName: 'Permanent Address', minWidth: 200, flex: 1, align: 'left', headerAlign: 'left' },

    {
      field: "appliedDate",
      headerName: "Applied Date",
      type: "text",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },

    {
      field: "requestedTimePreiodDate",
      headerName: "Eligiblity Date",
      type: "text",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },

    {
      field: "daysLeft",
      headerName: "Days Left",
      type: "number",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
  ];

  // useState(() => {
  //   handleGetPendingRegistrationRequest();
  // }, []);
  useEffect(() => {
    handleGetPendingRegistrationRequest();
  }, []);

  return (
    <>
      {loading && <Loader />}
      <MDBContainer fluid>
        <NewRegisteredRequestDataTable
          tableName="New Registration Requests"
          TableColumns={newMembershipRequestTableColumns}
          height={750}
          // onCellEditCommit={handleCellEditCommit}
        />
      </MDBContainer>
    </>
  );
};

export default NewRegReq;
